var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { urlify } from "core/utils/general";
/**
 * @NOTE FE managed slugs
 */
var slugs = {
    root: "/",
    tvGuide: "/tv-gids",
    tickets: "/doe-mee",
    programs: "/programmas",
    legoMasters: "/lego-masters/wij-zijn-lego-masters-bouw-zelf-mee-en-win",
};
var slugsToServerSideRedirect = ["/login"];
var settings = {
    auth: {
        loginCbUrl: GLOBALS.loginCbUrl,
        logoutCbUrl: GLOBALS.logoutCbUrl,
    },
    sessionDurationMs: 60 * 60 * 1000,
    brand: "vtm",
    language: "nl",
    blockKeys: {
        programHero: "programHero",
        marketingBanner: "marketingBanner",
    },
    tvGuide: {
        baseSlug: slugs.tvGuide,
        ownApiSlug: "/api/epg",
        staticSlug: "/tv-gids/static",
        apiSlug: "/tv-gids/api",
    },
    legoMasters: {
        baseSlug: slugs.legoMasters,
        curator: {
            jsUrl: "//cdn.curator.io/3.1/js/curator.js",
            cssUrl: "//cdn.curator.io/3.1/css/curator.css",
            containerId: "curator-feed-wijzijnlegomasters-layout",
            feedId: "50e024f4-b353-4a2d-bb4f-b9a6ba20a59e",
            debug: false,
        },
    },
    playerConfigForVideoPage: {
        autoplay: true,
        automute: false,
        single_play: true,
        pip: false,
        sticky: false,
    },
    slugs: slugs,
    slugsToServerSideRedirect: slugsToServerSideRedirect,
    programsSizePerList: 5,
    topPicks: {
        ownApiSlug: "/api/topPicks",
    },
    newsPlaylistId: 1482,
    search: {
        keys: {
            escape: 27,
            keyDown: 40,
            keyUp: 38,
        },
        threshold: 2,
        delay: 350,
    },
    meta: {
        affixes: {
            program: "De leukste fragmenten en acties",
            contest: "Wedstrijd",
        },
        twitterHandle: "@VTM",
        twitterCard: "summary_large_image",
        fbAppID: "303536159702149",
        defaultImage: "/images/vtm-default-image.jpg",
        defaultDescription: "Kleurt je dag",
    },
    characterLimit: {
        card: 65,
        topPick: 45,
        heroDescription: 200,
        banner: 100,
    },
    initialSize: {
        recentVideos: 15,
        relatedVideos: 15,
        popularPrograms: 10,
    },
    mobileNav: {
        height: 67,
        maxWidth: 768,
    },
    imageSize: {
        cardBoxCover: { width: 300, height: 450 },
        cardBoxCoverLandscape: { width: 500, height: 281 },
    },
    tracking: {
        hero: {
            category: {
                program: "Program",
                custom: "Custom",
                other: "Other",
            },
        },
        vtmGo: {
            live: "VTM GO live",
            program: "VTM GO program",
        },
        listNames: {
            topNav: "top nav",
            highlights: "highlights",
            recentVideos: "recent videos",
            popularPrograms: "popular programs",
            popularOnVtm: "populair op VTM",
            movies: "films",
            experienceHighlights: "experience highlights",
            highlights2: "highlights 2",
            extra: "extra",
            extra2: "extra 2",
            extra3: "extra 3",
            extra4: "extra 4",
            extra5: "extra 5",
            extra6: "extra 6",
            extra7: "extra 7",
            extra8: "extra 8",
            relatedVideos: "related videos",
            onAirPrograms: "on air programs",
            comingSoonPrograms: "coming soon programs",
            searchResults: "search result exact",
            topPicks: "top picks",
            programHero: "program hero",
            customHero: "custom hero",
            teams: "teams",
            other: "other",
            story: "💩",
            season: "season",
            VTMBanner: "vtm banner",
            programCard: "vtm-go-overview-card",
            tickets: "tickets swimlane",
            ticketHighlight: "tickets program page highlight",
        },
        impressionThreshold: {
            default: 0.5,
            hero: 1,
        },
        linkType: {
            program: "Program",
            tvGuide: "TV guide detail",
        },
    },
    seasonLane: {
        titleLogo: "/images/logos/vtm-go-color.svg",
        fallbackImages: {
            webp: "/images/vtmgo-fallback.webp",
            jpg: "/images/vtmgo-fallback.jpg",
        },
    },
    urls: {
        testOrigin: "https://vtm.be",
        landingPage: "https://vtm.be",
        vtmGo: "https://www.vtmgo.be",
        vtmgoLive: function (channel) {
            return "https://www.vtmgo.be/live-kijken/".concat(channel);
        },
        vtmgoOnDemand: function (title, uuid) {
            return "https://www.vtmgo.be/".concat(urlify(title), "~").concat(uuid);
        },
        vtmgoEpisode: function (uuid) { return "https://www.vtmgo.be/afspelen/".concat(uuid); },
        vtmgoMyList: function (vtmgoUrl) { return "".concat(vtmgoUrl, "/toevoegen-aan-mijn-lijst"); },
        myChannelsEmbedApi: function (myChannelsVideo, configId) {
            return "https://".concat(GLOBALS.myChannelsApiUrl, "/v3/embeds/video/").concat(myChannelsVideo, "?config_id=").concat(configId, "_default&brand=net.persgroep.brand.vtm");
        },
        myChannelsPlaylistEmbedApi: function (myChannelsPlaylist, configId) {
            return "https://".concat(GLOBALS.myChannelsApiUrl, "/v3/embeds/video-playlist-inline/").concat(myChannelsPlaylist, "?config_id=").concat(configId, "_default&brand=net.persgroep.brand.vtm");
        },
        absoluteUrl: function (origin, slug) {
            if (slug.startsWith("/"))
                return "".concat(origin).concat(slug);
            if (slug.startsWith("http"))
                return slug;
            return "".concat(origin, "/").concat(slug);
        },
    },
};
export var config = __assign(__assign({}, GLOBALS), settings);
